const accessByPermissions = (permissionKey, user) => {
  return !!(user && user.permissions.find(p => permissionKey === p.key));
};

export default accessByPermissions;
